export function addScrollListeners() {
    window.addEventListener('scroll', debounce(this.handleScroll, 100));
}

export function handleScroll() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const clientHeight = window.innerHeight || document.documentElement.clientHeight;
    const loaderNext = this.paginationNextElement;
    this.direction = scrollTop > this.lastScrollTop ? 'next' : 'prev';
    this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;

    // console.log('this.direction',this.direction)
    // console.log('scrollTop',scrollTop)
    // console.log('clientHeight',clientHeight)
    // console.log('this.paginationNextElement',this.paginationNextElement.getBoundingClientRect().bottom)
    // console.log('scrollHeight',scrollHeight)
    // console.log('this.settings.offset',this.settings.offset)

    if ((this.direction === 'prev' && scrollTop <= this.firstItemTopPosition + this.settings.offset) ||
        (this.direction === 'next' && loaderNext && scrollTop + clientHeight >= loaderNext.getBoundingClientRect().bottom + scrollTop - this.settings.offset)) {
        if (!this.loading) {
            this.loadContent();
        }
    }
}

export function scrollToHashElement() {
    const hash = window.location.hash;
    if (hash) {
        const elementId = hash.substring(1);
        const element = document.getElementById(elementId);
        if (element) {
            element.scrollIntoView({
                behavior: 'instant',
                block: 'center',
            });
        }
    }
}